export default __webpack_public_path__ + "static/bc_en_4-06c5352e9439a069c9847e0e8b81f356.mp4";